module.exports = __webpack_public_path__ + "img/image.2fde581e.svg";